import { Dialog, Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import DialogTitle from "../../../../componentLibrary/DialogTitle";
import MenuSelectorCard from "../../../../components/MenuOrder/MenuSelectorCard";
import { KioskMealMenuPreviewFragment } from "../../../../types";
import { GuestOrderingBadge } from "./GuestOrderingBadge";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      margin: theme.spacing(2),
    },
  })
);

interface SelectMenuModalProps {
  open: boolean;
  onClose: () => void;
  menus: readonly KioskMealMenuPreviewFragment[];
  onSelectMenu: (mealMenu: KioskMealMenuPreviewFragment) => void;
}

export const SelectMenuModal = ({ open, onClose, menus, onSelectMenu }: SelectMenuModalProps) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="body">
      <DialogTitle title="Select Menu" onClose={onClose} />
      {menus.map(mealMenu => (
        <MenuSelectorCard
          key={mealMenu.id}
          mealMenu={mealMenu}
          onClick={() => onSelectMenu(mealMenu)}
          disabled={!mealMenu.isGuestOrderingEnabled}
          className={classes.card}
        >
          <GuestOrderingBadge enabled={mealMenu.isGuestOrderingEnabled} />
        </MenuSelectorCard>
      ))}
    </Dialog>
  );
};
